import { HomepageService } from '@domain/usecases/homepage/HomepageService';

import { makePuzzleRepository } from './makePuzzleRepository';

export const makeHomepageService = (): HomepageService => {
	const puzzleRepository = makePuzzleRepository();

	return new HomepageService(puzzleRepository);
};
